import React from "react";
import Author from "../author";
import ChapterPreviewV2 from "../chapter-preview-v2";
import Contact from "../contact";
import Footer from "../global/footer";
import Header from "../global/header";
import Herov2 from "../herov2";
import Testimonial from "../testimonial";

const Version02 = ({header, footer}) => {
  const {menuv_c} = footer;
  return (
    <>
      <Header header={header} />
      <Herov2 isBg="yes"/>           
      <ChapterPreviewV2 isBg="" />
      <Author isBg="yes" />
      <Testimonial isBg=""/>
      <Contact isBg="yes"/>
      <Footer isBg="yes" menu={menuv_c} />
    </>
  );
};

export default Version02;
